import React from 'react';
import { Route, Routes } from 'react-router-dom';

import Account from '../../../containers/Account/Account';
import ContactRecommendations from '../../../containers/Account/Network/ContactRecommendations/ContactRecommendations';

const SUBTAB_PATHS = {
  '/': '',
  'sync-sources': 'sync-sources',
  'csv-import-history': 'csv-import-history',
  'linkedin-import-history': 'linkedin-import-history',
  'csv-import': 'csv-import',
  'linkedin-import': 'linkedin-import-zip',
};

const NetworkBase = () => (
  <Routes>
    <Route>
      <Route path="contact/:contactId/recommendations" element={<ContactRecommendations />} />
      {Object.keys(SUBTAB_PATHS).map((path) => (
        <Route exact path={path} key={path} element={<Account tab="network" subTab={SUBTAB_PATHS[path]} />} />
      ))}
    </Route>
  </Routes>
);

export default NetworkBase;
